module.exports = __webpack_public_path__ + "media/images/front/favicon-32x32-8a1152cd29629aac9b1933a784e62ee7.png";